// extracted by mini-css-extract-plugin
export default {"root":"styles_root__7Rby6","dragging-over":"styles_dragging-over__nOCsM","draggingOver":"styles_dragging-over__nOCsM","color":"styles_color__xkolU"};